var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance-page"},[_c('div',{staticClass:"maintenance-card"},[_c('h1',[_vm._v("Sitio en mantenimiento")]),_c('p',[_vm._v(" Estamos realizando una pausa operativa temporal. Intenta nuevamente en unos minutos. ")])])])
}]

export { render, staticRenderFns }